// clmConfig.jsx — design tokens, ISA-95 lane definitions, SVG layout geometry.
// Pure data/constants consumed by the functions file (CLMStudio.jsx) and never mutated.

/* ---- THEME (industrial / control-room) ---- */
export const T = {
  bg: "#070b12", bg2: "#0b1220", panel: "#0e1726", panel2: "#121d30",
  line: "rgba(120,170,220,0.13)", line2: "rgba(120,170,220,0.22)",
  ink: "#e9f1fb", ink2: "#93a8c4", ink3: "#5a708c",
  plmsi: "#22d3c5", cpi: "#ff7a45", boundary: "#ff4d6d", b2mml: "#5be584",
  gold: "#ffcc4d", violet: "#a78bfa", blue: "#4aa8ff", pink: "#ff5d8f",
  tc: "#4dd0ff", erp: "#ffcc4d", mes: "#4aa8ff",
};

export const FONT_DISPLAY = "'Sora','Segoe UI',sans-serif";
export const FONT_BODY = "'Space Grotesk','Segoe UI',sans-serif";
export const FONT_MONO = "'IBM Plex Mono','JetBrains Mono',monospace";

/* ---- ISA-95 LANES ---- */
export const LANES = [
  { id: "L4", label: "ENTERPRISE",          sub: "ERP · PLM · Cloud · Analytics", iso: "ISA-95 Level 4" },
  { id: "L3", label: "MFG OPERATIONS",      sub: "MES · APS · OEE · Gateways",    iso: "ISA-95 Level 3" },
  { id: "L2", label: "SUPERVISORY CONTROL", sub: "Edge · HMI · Quality",          iso: "ISA-95 Level 2" },
  { id: "L1", label: "SENSING & ACTUATION", sub: "PLC · CNC · Robots · IIoT",     iso: "ISA-95 Level 1" },
  { id: "L0", label: "PHYSICAL PROCESS",    sub: "Conveyors · WIP · Production",  iso: "ISA-95 Level 0" },
];
export const LANE_COLOR = { L4: "#ffcc4d", L3: "#4aa8ff", L2: "#ff8a3d", L1: "#22d3c5", L0: "#8fb8d8" };

/* ---- SVG LAYOUT GEOMETRY ---- */
export const LANE_Y = { L4: 70, L3: 250, L2: 440, L1: 610, L0: 770 };
export const LANE_H = { L4: 150, L3: 170, L2: 140, L1: 140, L0: 110 };
export const GUT = 150;
export const CANVAS_W = 1560;
export const CANVAS_H = 910;
export const NODE_W = { hub: 158, gateway: 104, bus: 150, app: 138, device: 116, physical: 150, external: 124 };
export const NODE_H = { hub: 70, gateway: 58, bus: 64, app: 58, device: 56, physical: 52, external: 64 };

export const laneMid = (lvl) => LANE_Y[lvl] + LANE_H[lvl] / 2;
